angular.module( 'acme.view.application.membership.categories.create.mapping', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.directive.detailList',
  'acme.view.application.membership.categories.create.mapping.controllers'
])

.config(function config( $stateProvider ) {

  var membershipCategoriesCreateMapping = {
    name: 'application.membership.categories.create.mapping',
    url: '/mapping',
    views: {
      "subview-main": {
        controller: 'MembershipCategoriesCreateMappingController',
        templateUrl: 'views/application/views/membership/categories/create/mapping/mapping.tpl.html'
      }
    },
    data: {
      pageTitle: 'Create Membership Category'
    }
  },
  membershipCategoriesEditMapping = {
    name: 'application.membership.categories.edit.mapping',
    url: '/mapping',
    views: {
      "subview-main": {
        controller: 'MembershipCategoriesCreateMappingController',
        templateUrl: 'views/application/views/membership/categories/create/mapping/mapping.tpl.html'
      }
    },
    data: {
      pageTitle: 'Edit Membership Category'
    }
  };

    $stateProvider
      .state(membershipCategoriesCreateMapping)
      .state(membershipCategoriesEditMapping);
});
